export const PROJECT_SERVICE_IDS = [
  'openproject',
  'gitea',
  'woodpecker',
  'nextcloud',
  'collabra',
] as const;

export type ProjectServiceId = (typeof PROJECT_SERVICE_IDS)[number];

export function normalizeProjectServices(
  values: readonly string[] | null | undefined,
): ProjectServiceId[] {
  const known = new Set<string>(PROJECT_SERVICE_IDS);
  return [...new Set((values || []).filter((value): value is ProjectServiceId => known.has(value)))];
}

/** Prefer API-provided installed services; fall back to public integration inventory. */
export function resolveInstalledProjectServices(
  fromApi: readonly string[] | null | undefined,
  fromPublicIntegration: readonly string[] | null | undefined,
): ProjectServiceId[] {
  const api = normalizeProjectServices(fromApi);
  if (api.length > 0) return api;
  return normalizeProjectServices(fromPublicIntegration);
}

